window.setupDotDotDot = wrapper =>
  $("[data-dotdotdot]", wrapper).each((i, element) =>
    $(element).dotdotdot({
      // dotdotdot: +element.getAttribute("data-dotdotdot") || 'auto'
      // useNativeDotDotDot: false
    })
  )
;

$(document).ready(function() {
  setupDotDotDot(document.body);
  return $(window).resize(() => setupDotDotDot(document.body));
});



// WEBPACK FOOTER //
// ./app/webpack/frontend/config/dotdotdot.js